import React from 'react';
import moment from 'moment';
import { Theme as MuiTheme } from '@mui/material';
import styled from '@emotion/styled';
import { withTheme } from '@emotion/react';
import { Theme, ThemeProps } from '@theme/base';
import { mixins } from '@styles/mixins';
import { Icons } from '@model/common/icons';
import { TestId } from '@components/test-ids';
import { TextDescriptionFade } from '@components/common/description';
import { Icon } from '@components/common/generic-icon';
import { DATE_PICKER_FORMAT } from '@model/common';

/* ***************** *
 *       Types       *
 * ***************** */
export interface TourReviewProps {
  theme?: Theme;
  testId?: string;
  name: string;
  date: string;
  review: string;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container = styled.div(({ theme }: ThemeProps) => ({
  margin: `${theme.custom.spacing.large}px 0`,
  ['&:last-of-type']: {
    marginBottom: 0
  }
}));

const Wrapper = styled.div(({ theme }: ThemeProps) => ({
  ...mixins(theme).colourCard,
  display: 'flex'
}));

const InnerWrapper = styled.div(({ theme }: ThemeProps) => ({
  marginLeft: theme.custom.spacing.medium
}));

const NameRow = styled.div({
  display: 'flex',
  alignItems: 'center'
});

const Name = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  fontWeight: 'bold',
  paddingRight: 10
}));

const Date = styled.span(({ theme }: ThemeProps) => ({
  fontSize: '1.4rem',
  color: theme.custom.colors.group4.light
}));

const IconStyles = (theme?: MuiTheme) => ({ fontSize: '4rem', color: theme?.custom.colors.group6.base });

/* ************************* *
 *    TourReviewComponent    *
 * ************************* */

export const TourReviewComponent = ({ name, date, review, testId, theme }: TourReviewProps) => {
  return (
    <Container data-testid={testId || TestId.tourReview.main}>
      <Wrapper>
        <Icon name={Icons.QUOTE} css={IconStyles(theme)} />
        <InnerWrapper>
          <TextDescriptionFade description={review} fadeColour={theme?.custom.colors.group6.lighter} />
          <NameRow>
            <Name>{name}</Name>
            <Date>{moment(date).parseZone().format(DATE_PICKER_FORMAT)}</Date>
          </NameRow>
        </InnerWrapper>
      </Wrapper>
    </Container>
  );
};

export const TourReview = withTheme(TourReviewComponent);
